<template>
  <section>
    <h2 class="h2Title">{{board.boardName}} 게시물 조회</h2>
    <div class="formInfo">

      <dl class="infoCont">
        <dt class="formInfoTxt">제목 </dt>
        <dd class="formInfoArea">

          <v-col class="mgr">
            <template v-if="board.hasNotice && article.notice">
              <v-chip
                  class="ma-2"
                  color="primary"
              >
                공지
              </v-chip>
            </template>

            <template v-for="(c) in board.boardCategories">
              <template v-if="c.categoryId === article.categoryId">
                <v-chip
                    class="ma-2"
                    color="success"
                    v-bind:key="c.categoryId"
                >
                {{c.categoryName}}
                </v-chip>
              </template>
            </template>

            {{article.title}}

          </v-col>

        </dd>
        <dt class="formInfoTxt" v-if="article.notice && board.hasPeriod">공지기간 </dt>
        <dd class="formInfoArea" v-if="article.notice && board.hasPeriod">
          <template v-if="article.always">
            <v-chip
                class="ma-2"
                color="primary"
            >
              상시
            </v-chip>
          </template>
          <template v-else>
            {{period}}
          </template>
        </dd>

      </dl>
      <dl class="infoCont">
        <dt class="formInfoTxt">작성자 </dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="6">
            {{article.writer}}
          </v-col>
<!--          <v-col class="mgr" sm="2">-->
<!--            {{article.customDate}} / -->
<!--            {{  article.createdAt | moment('YYYY-MM-DD HH:mm:ss') }}-->
<!--          </v-col>-->
        </dd>
        <dt class="formInfoTxt">조회수 / 좋아요 </dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="1">
            <v-icon small>mdi-counter</v-icon> {{article.hits ? article.hits : 1}}
            /
<!--            <v-icon @click="reaction" small>mdi-thumb-up-outline</v-icon>-->
<!--            <v-icon @click="reaction" small>mdi-thumb-up</v-icon>-->
            <v-icon @click="reaction" color="red" small v-if="article.readUserHasReaction">mdi-heart</v-icon>
            <v-icon @click="reaction" small v-else>mdi-heart-outline</v-icon>
            {{article.reactionCount}}
          </v-col>
        </dd>
        <dt class="formInfoTxt">작성일 </dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="2">
            {{  article.createdAt | moment('YYYY-MM-DD HH:mm:ss') }}
          </v-col>
        </dd>
      </dl>

      <dl class="infoCont">
        <dt class="formInfoTxt">내용</dt>
        <dd v-viewer>
          <div v-if="!article.mobile">
            <viewer-quill :val="article.contents" />
          </div>
          <div v-html="article.contents.replace(/(?:\r\n|\r|\n)/g, '<br />')" v-else>
          </div>
        </dd>
      </dl>

      <dl class="infoCont" v-if="$route.params.id === '567'">
        <dt class="formInfoTxt">계좌정보</dt>
        <dd class="formInfoArea">
            은행명 : {{article.bank}} /
            계좌주 : {{article.accountHolder}} /
            계좌번호 : {{article.accountNumber}}
        </dd>
      </dl>
      <dl class="infoCont" v-if="$route.params.id === '567'">
        <dt class="formInfoTxt">회원정보</dt>
        <dd class="formInfoArea">
            <span v-if="article.targetUser" style="margin-right:5px">회원명 : {{article.targetUser.name}} </span>
            <v-btn class="vBtn" color="#1991eb" dark v-if="article.targetUser" @click="onClickUser(article.targetUser.userId, 'detail')"> 
              회원정보 확인
            </v-btn> 
        </dd>
      </dl>
 

      <dl class="infoCont" v-if="board.hasAttachment">
        <dt class="formInfoTxt">첨부 파일</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" >
            <div v-if="article.articleAttachments">
              <v-row v-for="f in article.articleAttachments" v-bind:key="f.fileId" class="ma-2">
                <v-btn text  @click.prevent="downloadFile(f)"><v-icon>{{ f.contentType.indexOf('image') === 0 ? 'mdi-image' : 'mdi-file' }}</v-icon>
                  <v-tooltip bottom v-if="f.contentType.indexOf('image') === 0">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                          v-bind="attrs"
                          v-on="on"
                      >
                        {{ f.fileRealName }}
                      </span>
                    </template>

                    <span>
                      <v-img :src="`/attachment/${f.fileContextPath}${f.thumbnail}`" max-height="200" max-width="200"/>
                    </span>
                  </v-tooltip>
                  <span v-else>{{ f.fileRealName }}</span>
                </v-btn>
<!--                <a :href="`${apiEndPoint}/board/${article.boardId}/article/${article.articleId}/file/${f.fileId}`" @click.prevent="downloadFile(f)">{{ f.fileRealName }}</a>-->
              </v-row>
            </div>
          </v-col>
        </dd>


<!--        <dt class="formInfoTxt" v-if="board.boardType === 'TYPE_PHOTO'"> 대표 이미지</dt>-->
<!--        <dd class="formInfoArea" v-if="board.boardType === 'TYPE_PHOTO'">-->
<!--          <v-col class="mgr" sm="2">-->
<!--            <img :src="`${endPoint}/board/${article.boardId}/article/${article.thumbnail}`" v-if="article.thumbnail"/>-->
<!--          </v-col>-->
<!--        </dd>-->
      </dl>
      <dl class="infoCont">
      </dl>
      <dl>
        <div class="btnStyleBx">
          <div class="btnCommon justify-center">
            <v-btn class="vBtn" color="#1991eb" dark @click="updateForm(article)">
              <v-icon left>mdi mdi-content-save</v-icon>
              수정
            </v-btn>
            <v-btn class="vBtn" dark @click="deleteArticle(article)">
              <v-icon left>mdi mdi-delete</v-icon>
              삭제
            </v-btn>
            <v-btn class="vBtn" color="#fafafa" @click="goList()">
              <v-icon left>mdi mdi-format-list-bulleted</v-icon>
              목록
            </v-btn>
          </div>
        </div>
      </dl>

        <dl class="infoCont" v-if="board.hasComment">
          <dt class="formInfoTxt">댓글 </dt>
          <dd class="formInfoArea">
            <v-col sm="8">
            <ul>
              <li>
                <v-form ref="formComment"   >

                  <v-col class="d-flex">
                    <v-col class="mgr" sm="2">
                      <v-text-field v-model="comment.writer" :rules="[rules.required]" label="작성자" dense />
                    </v-col>
                    <v-col class="mgr" sm="2">
                      <v-text-field v-model="comment.createdAt" :rules="[rules.iso8601]" label="작성일" placeholder="YYYY-MM-DD" dense maxlength="10"/>
                    </v-col>
                  </v-col>
                  <!-- <v-textarea v-model="comment.contents" rows="3" outlined auto-grow :rules="[rules.required]"></v-textarea> -->
                  <v-textarea v-model="o_contents" rows="3" outlined ></v-textarea>
                  <div class="btnStyleBx">
                    <div class="btnCommon justify-end">
                      <v-btn class="vBtn" color="success" dark @click="saveComment">
                        <v-icon left>mdi mdi-content-save</v-icon>
                        댓글 등록
                      </v-btn>
                    </div>
                  </div>
                </v-form>
              </li>
              <li>
                <div class="comment-wrap">
                  <div class="hd-box" >댓글 <em>{{ commentsCnt }}</em>
                  </div> 
                <!-- 댓글 시작 -->
                <Comment
                  v-for="(comment, key) in comments"
                  :key="key"
                  :id="comment.commentId"
                  :createId="comment.createdBy"
                  :author="comment.writer"
                  :date="comment.createdAt"
                  :content="comment.contents"
                  :children="comment.childrenList"
                  :totalChildren="comment.totalChildren"
                  :isDeleted="comment.deleted"
                  :upcomment="comment" 
                  :reCommentIndex="reCommentIndex"
                  :isVisibleCommentUpdateForm="isVisibleCommentUpdateForm"
                  :isVisibleReplyEditor="isVisibleReplyEditor"
                  @submit:reply="onSubmitReply"
                  @update:comment="onUpdateReply"
                  @remove="onClickRemoveComment" 
                  ></Comment>
                <!-- 댓글 종료 -->    
                </div>
              </li>
            </ul>
            </v-col>
          </dd>
        </dl>

    </div>
    <CommonPopup v-if="memberList" :tap="popupTab" :userId="userId"  @click:bgDimClose="popupMemberList"></CommonPopup>
  </section>
</template>

<script>
import articleApi from '@/api/ArticleApi'
import boardApi from '@/api/BoardApi'
import commentApi from '@/api/CommentApi'



// import ViewerTiptap from "@/views/component/ViewerTiptapComponent";
import ViewerQuill from "@/views/component/ViewerQuillComponent";
import CommonPopup from '@/views/include/common_popoup'
import _ from 'lodash'

import moment from "moment";
import Comment from '@/views/component/Comment';




export default {
  name: "ArticleForm",
  components: {
    ViewerQuill,
    CommonPopup,
    Comment
  },
  props: {
    id: String 
  },
  data: () => ({
    board:{},
    article: {
      title: null,
      contents: null,
      writer: null,
      always: true,
      customDate: null
    },
    /*
    comment: {
      content:null
    },
    */
    commentHeaders: [{value: 'writer'}, {value : 'contents'}, {value: 'actions'}],
    //comments:[],
    totalItems:0,
    options:{},
    period:null,
    apiEndPoint:process.env.VUE_APP_BASE_API,
    endPoint:process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      iso8601: value => (!value || !!/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/.test(value)) || '날짜 형식이 아닙니다.'
    },
    //editComment: {},
    popupTab: 'list',
    memberList: false,

    commentsCnt:0,
    comments:{},
    comment: {
      contents:""
    },
    recomment: {
      contents:""
    },
    editComment:{
      contents:""
    },
    o_contents:"",
    editCommentStatus:false,
    commentIndex: -1,
    reCommentIndex : -1, 

    isVisibleCommentUpdateForm : false,
    isVisibleReplyEditor:false,

  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    }, 
    isOpen(e){
      if(!e){
        this.memberList=false;
      }
    }
  },
  methods: {
    reaction() {
      articleApi.reaction(this.article.articleId, this.article.boardId).then(res => {
        if(res.data) {
          this.article.reactionCount = this.article.reactionCount +1;
          this.article.readUserHasReaction = true;
        } else {
          this.article.reactionCount = this.article.reactionCount -1;
          this.article.readUserHasReaction = false;
          // alert("이미 처리되었습니다.")
        }
      });
    },
    downloadFile(f) {

      articleApi.downloadFile(this.article.boardId, this.article.articleId, f.fileId)
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = f.fileRealName.slice(f.fileRealName.lastIndexOf('/') + 1);
        link.click()
        URL.revokeObjectURL(link.href)
      })
      .catch(error => {
        //console.log(error.response);
        //console.log(error.response.status);
        if(error.response.status === 404)
          alert("파일을 찾을 수 없습니다.");
        else
          alert(error.status);
      });
    },
    goList() {
      this.$router.push({path: `/board/${this.$route.params.id}/articles`})
    },
    deleteArticle(item) {
      if(confirm('삭제하시겠습니까?')) {
        articleApi.delete(item.boardId, item.articleId).then(() => {
          alert("삭제되었습니다.")
          this.goList();
        });
      }
    },
    updateForm(item) {
      this.$router.push({path:`/board/${item.boardId}/article/form/${item.articleId}`});
    },
    async saveComment() {
      //if (!await this.$refs.formComment.validate())
      //  return;
      if(this.o_contents.length==0){
        return alert('댓글을 한 글자 이상 입력해주세요.')
      } 
      this.comment.contents = this.o_contents;

      this.comment.createdAt = this.comment.createdAt ? this.comment.createdAt + "T00:00:00" : null;
      commentApi.save(this.$route.params.id, this.comment).then(() => {
        this.comment.contents = "";
        this.comment.createdAt = null;
        //this.$refs.formComment.resetValidation()
        this.o_contents = "";
        // this.$refs.formComment.reset();
        // this.comment.writer = this.$store.state.user.username;
        this.search();
      }).catch(error => {
        this.comment.createdAt = this.comment.createdAt.substr(0, 10);
        alert(error);
      });
    }, 
    async updateComment() {
      if(confirm('댓글을 수정하시겠습니까?')) {
        if (!await this.$refs.formListComment.validate())
          return;

        commentApi.save(this.$route.params.id, this.editComment).then(() => {
          this.$refs.formComment.resetValidation();
          (this.comments.filter(c => c.commentId === this.editComment.commentId)?.[0] ?? {}).contents = this.editComment.contents;
          this.editComment = {};
        });
      }
    },
    updateCommentForm(item) {
      this.editComment = _.cloneDeep(item);
    },
    cancelComment() {
      this.editComment = {};
    }, 
    deleteComment(item) {
      if(confirm('댓글을 삭제하시겠습니까?')) {
        commentApi.delete(this.article.boardId, item.commentId).then(() => {
          this.search();
        });
      }
    },    
    onSubmitReply(reply, id){  
      this.recomment = this.comment; 
      let tempContents = reply;
      if(tempContents.length==0){
        return alert('댓글을 한 글자 이상 입력해주세요.')
      } 

      this.recomment.articleId = this.article.articleId;
      this.recomment.boardId = this.article.boardId;
      this.recomment.upperCommentId = id;
      this.recomment.commentId = null;
      this.recomment.createdAt = null; 
      //console.log(" this.tempContents ---- ")
      //console.log( tempContents)
      //console.log(this.recomment.contents)
      //console.log(" this.recomment ---- ")
      //console.log(this.recomment)
      this.comment.contents = "";
      this.recomment.contents = tempContents; 
      //console.log(" this.recomment ---- ")
      //console.log(this.recomment)

      commentApi.save(this.article.boardId, this.recomment).then(() => {
        this.contents = "";
        this.reply = "";
        this.isVisibleReplyEditor = false;
        this.recomment.contents = "";
        this.reCommentIndex = -1;
        this.recomment.upperCommentId = "";
        this.comment.contents = "";
        this.o_contents = ""; 
        this.search();
      }) 
    },
    onUpdateReply(editreply, id, upcomment){   
      this.recomment = upcomment;
      let tempContents = editreply;
      if(tempContents.length==0){
        return alert('댓글을 한 글자 이상 입력해주세요.')
      }

      this.recomment.articleId = this.article.articleId;
      this.recomment.boardId = this.article.boardId;
      this.recomment.commentId = id; 
      this.recomment.contents = tempContents; 
      this.recomment.updateAt = null;
      commentApi.save(this.article.boardId, this.recomment).then(() => {
        this.editreply = "";
        this.recomment.contents = "";
        this.reCommentIndex = -1;
        this.recomment.upperCommentId = "";
        this.isVisibleCommentUpdateForm = false;
        this.search();
      }) 
    },   
    onClickRemoveComment(id){ 
      if(confirm('지금 삭제하시면 \n내용을 복구할 수 없습니다. 삭제하시겠습니까?')) {
        commentApi.delete(this.article.boardId, id).then(() => {
          this.search();
        });
      }
    },  
    popupMemberList(e){
      this.isOpen = e;
      this.memberList = e
      this.$emit('click:bgDim', this.memberList)
    },
    onClickUser(userId, popStatus){
      this.userId=userId
      this.popupTab=popStatus
      this.popupMemberList(true)
    },
    search() {
      if(this.article.articleId) {
        const {page, itemsPerPage, size} = this.options;
        let params = {
          ...this.param, ...{
            page: page,
            size: size ? size : itemsPerPage
          }
        };
        commentApi.list(this.article.boardId, this.article.articleId, params).then(data => {
          // console.log(data);
          this.totalItems = data.totalElements;
          this.comments = data.content;
          this.o_contents = ""; 
          //console.log("----------------o_contents")       
          //console.log(this.o_contents)       
        });
        commentApi.total(this.article.boardId, this.article.articleId).then(data => {
          //갯수 안맞아서 수정함
          this.commentsCnt = data;
        });
      }
    }, 

  },
  created() {

    if(this.$route.params.articleId) {
      articleApi.get(this.$route.params.id, this.$route.params.articleId).then(data => {

        // console.log(data);
        this.article = data;

        this.comment.articleId = this.article.articleId;
        this.comment.boardId = this.article.boardId;
        this.commentsCnt = data.commentCount;

        this.search();

        // this.article.customDate = this.article.createdAt.substr(0,10);

        this.period = [this.article.startDt, this.article.endDt].filter(d => d !== null).map(d => moment(d).format("YYYY년 MM월 DD일")).join(" ~ ");
      });
    }
    // this.article.writer = this.$store.state?.user?.username??'';

    boardApi.get(this.$route.params.id).then(data => {
      this.board = data;
    });

    this.comment.writer = this.$store.state.user.username;
  }
}
</script>

<style lang="scss">
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}

.commentList div.v-data-table__wrapper > table > tbody > tr > td:nth-child(1) {
  width: 120px !important;
}
.commentList div.v-data-table__wrapper > table > tbody > tr > td:nth-child(3) {
  width: 120px !important;
}
</style>